import { useRef, useState } from 'react'

import { faGlobeStand as GlobeIcon } from '@fortawesome/pro-light-svg-icons/faGlobeStand'

import Icon from '@space-core/components/icon'
import RadioButton from '@space-core/components/radioButton'

import { customMedia } from '@space-core/styles'
import styled from 'styled-components'

import type { ApplicationLanguageType } from './constants'
import { AVAILABLE_LANGUAGES } from './constants'

import '@hotmart/cosmos/dist/form/form.css'
import type { CustomLanguageProps } from './types'

import { Collapse } from '../collapse'

const LanguageCollapse = styled(Collapse)`
  --collapse-padding: 0;
`

const RadioOptions = styled.div`
  max-height: 12.375rem;

  ${customMedia.lessThan('md')`
    max-height: 8.875rem;
  `}

  ::-webkit-scrollbar {
    width: var(--spacer-1);
  }

  ::-webkit-scrollbar-track {
    margin-bottom: var(--spacer-3);
  }

  ::-webkit-scrollbar-thumb {
    background-color: var(--gray-200);
    border-radius: var(--border-radius-lg);
  }
`

const CustomLanguage = ({
  applicationLanguage,
  handleClickLanguageOption,
  labelCustomLanguage
}: CustomLanguageProps) => {
  const [selectedOption, setSelectedOption] = useState<ApplicationLanguageType>(applicationLanguage)
  const collapseRef = useRef<HTMLHcCollapseItemElement>(null)

  const handlerClickRadioButton = (value: ApplicationLanguageType) => {
    setSelectedOption(value)
    handleClickLanguageOption(value)
  }

  const renderCollapseLabel = () => (
    <div className='_d-flex _align-items-center _py-3 hot-dropdown__toggle'>
      <Icon icon={GlobeIcon} className='_mr-3 _text-4' />
      <div>
        <legend className='_text-gray-900 _text-2 _m-0'>{labelCustomLanguage}</legend>
        <p className='_text-gray-900 _text-1 _m-0'>
          {AVAILABLE_LANGUAGES[applicationLanguage]?.label}
        </p>
      </div>
    </div>
  )

  return (
    <LanguageCollapse ref={collapseRef} collapseActions={renderCollapseLabel()}>
      <Collapse.CollapseItem>
        <RadioOptions className='_overflow-auto _pl-6'>
          {Object.values(AVAILABLE_LANGUAGES).map((item) => (
            <RadioButton
              item={item}
              key={item.value}
              className='_py-4 _m-0'
              checked={item.value === selectedOption}
              handlerClickRadioButton={handlerClickRadioButton}
            />
          ))}
        </RadioOptions>
      </Collapse.CollapseItem>
    </LanguageCollapse>
  )
}

export default CustomLanguage
